export enum CommissionType {
    TERMINAL = 'TERMINAL',
    ONLINE = 'ONLINE',
    TRANSACTIONAL = 'TRANSACTIONAL',
}

export default CommissionType;
